const TOKEN_SPLIT_REGEX = /[\s,;|/\\-]+/;

const toNormalizedString = (value) =>
  String(value ?? "")
    .trim()
    .toLowerCase();

export function getSearchTokens(query) {
  const normalized = toNormalizedString(query);
  if (!normalized) return [];
  return [...new Set(normalized.split(TOKEN_SPLIT_REGEX).map((token) => token.trim()).filter(Boolean))];
}

export function matchesSearchQuery(values, query) {
  const tokens = getSearchTokens(query);
  if (tokens.length === 0) return true;

  const searchableValues = (Array.isArray(values) ? values : [values])
    .map((value) => toNormalizedString(value))
    .filter(Boolean);

  if (searchableValues.length === 0) return false;
  return tokens.every((token) => searchableValues.some((value) => value.includes(token)));
}
